import { getAuthToken, getCookieUser } from 'utils/authTyped';

import type { ICredentialSourcePort } from '@identity/application/ports';

/**
 * Reads the Parrot session: the token that authorizes the in-app flows and the id of its owner.
 *
 * It re-models nothing and reads on every call, so a late login or a rotation reaches the next
 * request. There is no `save` and no `clear`: identity must not be able to create or delete the
 * session.
 */
export const sessionCredentialSource: ICredentialSourcePort = {
  read: () => getAuthToken()?.accessToken ?? null,
  readUserId: () => getCookieUser()?.uuid ?? null,
};
